"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ImageWidget_1 = require("../../ImageWidget");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var ImageFrameRepositionToolbar = (function (_super) {
    __extends(ImageFrameRepositionToolbar, _super);
    function ImageFrameRepositionToolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.onKeepChanges = function () {
            _this.props.telemetry.repositionedImageInFrame();
            _this.props.onKeepChanges();
        };
        _this.menuElem = react_1.default.createRef();
        return _this;
    }
    ImageFrameRepositionToolbar.prototype.render = function () {
        var _a = this.props, zoomOut = _a.zoomOut, zoomIn = _a.zoomIn, setZoomLevel = _a.setZoomLevel, currentZoom = _a.currentZoom, onCancelChanges = _a.onCancelChanges;
        return (react_1.default.createElement("div", { ref: this.menuElem, style: { left: "".concat(this.props.leftPosition, "px"), position: "absolute", width: "fit-content" }, className: "image-frame-reposition-toolbar" },
            react_1.default.createElement(kaleidoscope_1.Panel, { className: "editor-toolbar", theme: kaleidoscope_1.PanelTheme.Dark },
                react_1.default.createElement("div", { className: "editor-toolbar__button", onClick: zoomOut },
                    react_1.default.createElement(icons_1.ZoomOut, null)),
                react_1.default.createElement("div", { className: "center-aligned", style: { width: "246px" } },
                    react_1.default.createElement(kaleidoscope_2.Slider, { value: currentZoom, onChange: setZoomLevel, theme: kaleidoscope_2.SliderTheme.Dark, minimum: ImageWidget_1.MIN_SCALE, maximum: ImageWidget_1.MAX_SCALE, stepSize: 0.1, label: "zoom level" })),
                react_1.default.createElement("div", { className: "editor-toolbar__button", onClick: zoomIn },
                    react_1.default.createElement(icons_1.ZoomIn, null)),
                react_1.default.createElement("div", { className: "editor-toolbar__button", onClick: this.onKeepChanges },
                    react_1.default.createElement(icons_1.Tick, null)),
                react_1.default.createElement("div", { className: "editor-toolbar__button", onClick: onCancelChanges },
                    react_1.default.createElement(icons_1.Close, null)))));
    };
    ImageFrameRepositionToolbar = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ImageFrameRepositionToolbar);
    return ImageFrameRepositionToolbar;
}(react_1.default.Component));
exports.default = ImageFrameRepositionToolbar;
